import { nanoid } from 'nanoid';
import { gameConfigStore, betStore } from '@pascal/pascal-core';
import { marketsStore } from '../store/marketsStore';
import { doBetStore } from '../store/doBetStore';
import { CardTypes } from '../enums';

// let activeSection;
export const repliedCallback = () => {
  const { repliedBetData } = betStore;
  marketsStore.setupMarketsDataByType(repliedBetData.replayData.gameConfiguration.markets);
  doBetStore.setBetAmount(repliedBetData.amount);

  gameConfigStore.setLimits(repliedBetData.replayData.limits);

  marketsStore.setLatestMarkets([
    {
      card: CardTypes[repliedBetData?.roundData?.previousCard],
      id: nanoid(),
      isRotated: true,
      anim: false,
    },
  ]);

  // let mainActiveSection;
  // repliedBetData.additionalParams.markets.forEach(({ market }) => {
  //   const findResult = marketsStore.mainMarketsData.find(
  //     (item) => item.marketType === market.marketType
  //   );
  //
  //   if (findResult) {
  //     mainActiveSection.push(mainActiveSection);
  //   }
  // });

  // const mainActiveSection = marketsStore.mainMarketsData.find(
  //   (item) => item.marketType === repliedBetData.additionalParams
  // );

  // if (mainActiveSection) {
  //   activeSection = mainActiveSection;
  //   marketsStore.setReplayActiveMainMoreSection(1);
  //   marketsStore.setSelectedMarket({ ...activeSection, hiOrLo: null });
  // }
  //
  // if (!activeSection) {
  //   marketsStore.moreMarketsData.forEach((itemRow) => {
  //     const moreActiveSection = itemRow.find(
  //       (item) => item.marketType === repliedBetData.additionalParams
  //     );
  //     if (moreActiveSection) {
  //       activeSection = moreActiveSection;
  //       marketsStore.setReplayActiveMainMoreSection(2);
  //       marketsStore.setSelectedMarket({ ...activeSection, hiOrLo: null });
  //     }
  //   });
  // }
  //
  // if (!activeSection) {
  //   activeSection = marketsStore.hiLoMarketsData.find(
  //     (item) => item.marketType === repliedBetData.additionalParams
  //   );
  //
  //   marketsStore.setHiOrLoMarket(
  //     mainHiLoParser(repliedBetData.roundData.previousCard, marketsStore.hiLoMarketsData)
  //   );
  //   marketsStore.setReplayActiveHILoSection(activeSection.betType);
  //   marketsStore.setSelectedMarket(activeSection);
  // }
};
